import { validateEmail, waitForGtag } from '../../core/helpers';

export default class CustomerReferralAccount {
  elements;
  share_url;
  is_sending_email;

  constructor() {
    if (window.theme.isLoggedIn === false) {
      window.location.href = '/account/login';
      return;
    }

    this.is_sending_email = false;

    // App Proxy URL
    this.share_url = '/apps/promo/invite-referral';

    this.elements = {
      copyLinkButton: document.querySelector('[data-copy-referral-link]'),
      sendEmailButton: document.querySelector('[data-send-referral-email]'),
      sendMoreEmailButton: document.querySelector('[data-send-more-referral-email]'),
      copyLinkInput: document.getElementById('AccountReferralShareLink'),
      emailInput: document.getElementById('AccountReferralShareEmail'),
    };

    if (this.elements.copyLinkButton !== null) {
      this.elements.copyLinkButton.addEventListener('click', this.handleCopyLink.bind(this));
    }

    if (this.elements.sendEmailButton !== null) {
      this.elements.sendEmailButton.addEventListener('click', this.handleSendEmail.bind(this));
    }

    if (this.elements.sendMoreEmailButton !== null) {
      this.elements.sendMoreEmailButton.addEventListener('click', this.handleSendMoreEmail.bind(this));
    }

    // [ADA]
    document.querySelectorAll('[data-copy-referral-link], [data-send-referral-email]').forEach((button) => {
      button.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    });
  }

  // Copy the value of the input to the clipboard
  handleCopyLink = async (e) => {
    await navigator.clipboard.writeText(this.elements.copyLinkInput.value);

    this.elements.copyLinkButton.querySelector('span').textContent = 'Copied!';

    window.setTimeout(() => {
      this.elements.copyLinkButton.querySelector('span').textContent = 'Copy link';
    }, 500);
  };

  handleSendEmail = async (e) => {
    if (this.is_sending_email === true) {
      return;
    }

    const email_form = document.getElementById('AccountReferralShareEmailForm');
    const email_value = this.elements.emailInput.value;
    const errors = email_form.querySelector('.errors');

    errors.classList.remove('active');
    errors.textContent = '';

    if (!validateEmail(email_value)) {
      errors.textContent = 'Please enter a valid email.';
      errors.classList.add('active');
      return;
    }

    if (email_value === window?.theme?.customer?.email) {
      errors.textContent = 'You cannot use your own email..';
      errors.classList.add('active');
      return;
    }

    try {
      this.is_sending_email = true;
      this.elements.sendEmailButton.querySelector('span').textContent = 'Please wait...';

      // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
      const response = await fetch(`${this.share_url}${window.theme.customer.app_signature}`, {
        method: 'POST',
        body: JSON.stringify({
          share_type: 'email',
          share_value: email_value,
          share_customer_id: window.theme.customer.id,
          share_customer_email: window.theme.customer.email,
        }),
      });

      if (!response.ok) {
        const error_message = await response.json();
        console.error(error_message);
        throw new Error(error_message.Error);
      }
  
      const json = await response.json();
      console.log('success', json);

      this.is_sending_email = false;
      this.elements.sendEmailButton.querySelector('span').textContent = 'Send email';
      this.elements.emailInput.value = '';
      document.querySelector('.account-referral-share__email').classList.add('sent');
      document.querySelector('.account-referral-share__email-sent').classList.add('active');

      waitForGtag(() => {
        gtag('event', 'referral_promo', {
          'step': 'email-sent',
        });
      });

    } catch (error) {
      console.error(error.message);

      this.is_sending_email = false;
      this.elements.sendEmailButton.querySelector('span').textContent = 'Send email';
      errors.textContent = 'An error occured, please try later.';
      errors.classList.add('active');
    }
  };

  handleSendMoreEmail = (e) => {
    document.querySelector('.account-referral-share__email').classList.remove('sent');
    document.querySelector('.account-referral-share__email-sent').classList.remove('active');
  };
}
